import { CropConfig } from '../../store/Seeds/CropsSlice';
import { mapObject } from '../mapObject';
import { ICalcProduct } from './ProductRollupCalc';

/** Provide bag size info for product calculator. */
export interface IBagSizeProvider
{
	/** Seeds per bag. */
	bagSize(product: ICalcProduct): number;
}

export class BagSizeProvider implements IBagSizeProvider
{
	private lookup: Record<string, number>;

	public constructor()
	{
		// TODO: Pull from new v7 endpoint.
		this.lookup = mapObject(CropConfig(), (config, cropId) => config.seedsPerBag);
	}

	public bagSize(product: ICalcProduct): number 
	{
		return this.lookup[product.cropId];
	}
	
}